import { Component, Inject, Input, ViewChild } from '@angular/core';
import { SharedRouteECMRActionsComponent } from '@shared/src/components/route/cmr/digitaldocument/actions/shared.route.ecmr.actions.component';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { RoutePartCMRSignatureAgents, RoutePartCMRSignatureAgentsEnum } from '@shared/src/controllers/route/cmr/RoutePartCMRSignatureAgents';
import { HLong } from '@shared/src/datatypes/HLong';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { HString, PhaseCardDto, PhaseController } from '@shared/src/public-api';

@Component({
  selector: 'shared-phase-cmr',
  templateUrl: './shared.phase.cmr.component.html',
  styleUrls: ['./shared.phase.cmr.component.scss'],
})
export class SharedPhaseCMRComponent {

  constructor(private phaseController: PhaseController,
    @Inject('HomeController') protected homeController: HomeController) {

  };

  public __phase: PhaseCardDto | null = null;
  @Input()
  set phase(value: PhaseCardDto) {
    if (this.__phase === value)
      return;
    this.__phase = value;
    this.loadData();
  }
  get phase(): PhaseCardDto | null {
    return this.__phase;
  }

  public __phaseId: number = 0;
  @Input()
  set phaseId(value: number) {
    if (this.__phaseId === value)
      return;
    this.__phaseId = value;
    this.loadPhaseFromPhaseId();
  }
  get phaseId(): number {
    return this.__phaseId;
  }

  public loadPhaseFromPhaseId() {
    if (!HLong.isNullOrNullLong(this.__phaseId))
      this.phaseController.getPhase(this.__phaseId).subscribe(d => {
        this.phase = d;
      });
  }

  getUUID() {
    return this.uuid;
  }
  getAgent() {
    return this.agent;
  }


  public uuid: string = "";
  public uri: string = "";
  public agent: RoutePartCMRSignatureAgents = RoutePartCMRSignatureAgents.none;

  public options: OptionsStripDto | null = null;
  public optionSelected: string = "";

  @ViewChild(SharedRouteECMRActionsComponent) actionsComponent: SharedRouteECMRActionsComponent;

  public clickOption(option: OptionDto) {
    this.optionSelected = option.optionId;
    if (this.optionSelected != "QR") {
      let agents = HString.toLowerCase(option.optionId) as keyof typeof RoutePartCMRSignatureAgents;
      this.agent = RoutePartCMRSignatureAgents[agents] || RoutePartCMRSignatureAgents.none;
      this.phaseController.getSignUUIDURI(this.phase.phaseId, this.agent).subscribe(d => {
        this.uri = d;
      });
    } else {
      this.uri = this.homeController.getPhaseToExternalCMRsUUIDQR(this.uuid);
    }
  }

  public onActionExecuted() {
    this.uuid = null;
    this.loadData();
  }

  ngOnInit() {

  }
  public loadData() {
    if (this.phase)
      this.phaseController.getSignUUID(this.phase.phaseId).subscribe(d => {
        this.uuid = d;

        if (this.uuid != null && this.uuid != "") {

          let defaultagent: RoutePartCMRSignatureAgents = RoutePartCMRSignatureAgentsEnum.getDefaultAgentByPhase(this.phase);
          this.options = new OptionsStripDto();
          this.options.add(OptionDto.build(RoutePartCMRSignatureAgentsEnum.ID(RoutePartCMRSignatureAgents.sender), RoutePartCMRSignatureAgentsEnum.CAPTION(RoutePartCMRSignatureAgents.sender), RoutePartCMRSignatureAgentsEnum.HELP(RoutePartCMRSignatureAgents.sender), "", 10, -1, -1, RoutePartCMRSignatureAgents.sender == defaultagent, false));
          this.options.add(OptionDto.build(RoutePartCMRSignatureAgentsEnum.ID(RoutePartCMRSignatureAgents.carrier), RoutePartCMRSignatureAgentsEnum.CAPTION(RoutePartCMRSignatureAgents.carrier), RoutePartCMRSignatureAgentsEnum.HELP(RoutePartCMRSignatureAgents.carrier), "", 20, -1, -1, RoutePartCMRSignatureAgents.carrier == defaultagent, false));
          this.options.add(OptionDto.build(RoutePartCMRSignatureAgentsEnum.ID(RoutePartCMRSignatureAgents.driver), RoutePartCMRSignatureAgentsEnum.CAPTION(RoutePartCMRSignatureAgents.driver), RoutePartCMRSignatureAgentsEnum.HELP(RoutePartCMRSignatureAgents.driver), "", 30, -1, -1, RoutePartCMRSignatureAgents.driver == defaultagent, true));
          this.options.add(OptionDto.build(RoutePartCMRSignatureAgentsEnum.ID(RoutePartCMRSignatureAgents.consignee), RoutePartCMRSignatureAgentsEnum.CAPTION(RoutePartCMRSignatureAgents.consignee), RoutePartCMRSignatureAgentsEnum.HELP(RoutePartCMRSignatureAgents.consignee), "", 40, -1, -1, RoutePartCMRSignatureAgents.consignee == defaultagent, false));

          this.options.add(OptionDto.build("QR", "SHAREDPHASECMR.QR.CAPTION", "SHAREDPHASECMR.QR.HELP", "", 50, -1, -1, false, false));

          this.optionSelected = RoutePartCMRSignatureAgentsEnum.ID(defaultagent);

          this.clickOption(this.options.getActualSelected());

        }
      });
  }

  onSignedChanged() {
    this.actionsComponent?.loadActions();
  }

  @Input()
  public defaultSign: boolean = true;

  @Input()
  public contract: boolean = false;

  public pretty(value: any): string {
    return JSON.stringify(value);
  }
}
